export const validateEmail = (email: string | undefined) => {
  if (!email) return 'Please enter an email address';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address';
  } else {
    return '';
  }
};
